export default __webpack_public_path__ + "static/media/about-banner.fa848051.jpg";